<template>
  <div id="video_v" class="relativeItem">
    <!--顶部下载-->
    <!-- <div class="top-d flex-box pmd">
      <div class="lunbo" id="u">
        <div class="u1 flex-box">
          <div v-for="(n, index) in list" :key="index">
            <img :src="n.avatar" class="head noevents-img" />
            <span>{{ n.title }}</span>
          </div>
        </div>
        <div class="u2 flex-box"></div>
      </div>
      <a class="imgBlock download-btn absoluteItem centerY" id="download1">
        <img
          src="../../assets/share/video_shere(3).png"
          class="head imgBlock noevents-img"
        />
      </a>
    </div> -->

    <!--视频区域-->
    <div class="relativeItem video-shell">
      <!-- <video id="video" controls>
        <source :src="v_info.vod_id" />
      </video> -->
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="playsinline"
        :options="playerOptions"
        @ended="video_over()"
        @canplay="onPlayerCanplay"
      ></video-player>

      <!--覆盖元素-->
      <!--头像-->
      <div class="part1 flex-box absoluteItem" v-show="!is_over">
        <div class="head">
          <img :src="v_info.avatar" class="imgBlock noevents-img" />
        </div>
        <div>
          <p class="p1">{{ v_info.nickname }}</p>
          <p class="p2">朱贝号{{ v_info.usernumber }}</p>
        </div>
        <a id="download2">
          <img
            src="../../assets/share/video_shere(6).png"
            class="imgBlock noevents-img"
          />
        </a>
      </div>

      <div class="part2 absoluteItem" v-show="!is_over">
        <p class="p1 apostrophe">{{ v_info.title }}</p>
        <div class="p2 flex-box relativeItem">
          <a class="allA" id="download3"></a>
          <img
            src="../../assets/videoIcon (1).png"
            class="imgBlock noevents-img"
          />
          <span>{{ v_info.zancount }}</span>
          <img
            src="../../assets/videoIcon (4).png"
            class="imgBlock noevents-img"
          />
          <span>{{ v_info.commentcount }}</span>
          <img
            src="../../assets/videoIcon (2).png"
            class="imgBlock noevents-img"
          />
          <span>分享</span>
        </div>
      </div>

      <!--视频结束区域-->
      <div class="over absoluteItem" v-show="is_over">
        <!--列表-->
        <ul class="flex-box">
          <li
            v-for="(n, index) in list"
            :key="index"
            class="relativeItem"
            v-show="index < 4"
          >
            <a class="allA" @click="play_other(index)"></a>
            <img :src="n.path" class="imgBlock noevents-img cover" />
            <!-- <img v-lazy="n.showcover" class="imgBlock noevents-img absoluteItem centerImg" /> -->
            <!--播放图标-->
            <img
              src="../../assets/share/video_shere(1).png"
              class="play-icon imgBlock noevents-img absoluteItem centerImg"
            />

            <!--小视频类-->
            <div class="b-item video absoluteItem">
              <p class="p1 apostrophe">{{ n.title }}</p>
              <p class="p2">赞{{ n.zancount }} · 评论{{ n.commentcount }}</p>
            </div>
          </li>
        </ul>

        <!--底部按钮-->
        <div class="btn flex-box">
          <a class="imgBlock" @click="re_play">
            <img
              src="../../assets/share/video_shere(9).png"
              class="imgBlock noevents-img"
            />
          </a>
          <a class="imgBlock" id="download4">
            <img
              src="../../assets/share/video_shere(8).png"
              class="imgBlock noevents-img"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>











<script>
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";

// videojs
import videojs from "video.js";
window.videojs = videojs;

export default {
  name: "video_v",
  components: {},
  props: ["v_info", "list"],
  data() {
    return {
      playsinline: false,
      in_Android: false, //判断是否在安卓
      video: null, //视频播放对象
      is_over: false, //判断视频是否播放结束
      playerOptions: {
        autoplay: false, //如果true,浏览器准备好时开始回放。。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: this.v_info.video_address, //url地址
          },
        ],
        poster: this.v_info.imgs[0], //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          fullscreenToggle: false, //全屏按钮
        },
      },
    };
  },
  methods: {
    /**openinstall相关事务 */
    open_install_thing() {
      /*web页面向app传递的json数据(json string/js Object)，应用被拉起或是首次安装时，通过相应的android/ios api可以获取此数据*/
      // eslint-disable-next-line
      var data = OpenInstall.parseUrlParams(); //openinstall.js中提供的工具函数，解析url中的所有查询参数
      // eslint-disable-next-line
      new OpenInstall(
        {
          /*appKey必选参数，openinstall平台为每个应用分配的ID*/
          appKey: "tj3x4l",
          /*openinstall初始化完成的回调函数，可选*/
          onready: function () {
            var m = this,
              button2 = document.getElementById("download2"),
              button3 = document.getElementById("download3"),
              button4 = document.getElementById("download4");
            /*在app已安装的情况尝试拉起app*/
            m.schemeWakeup();
            /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
            button2.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
            button3.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
            button4.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
          },
        },
        data
      );
    },

    /**重新加载本页面播放其他视频*/
    play_other(index) {
      let url = window.location.origin + window.location.pathname;
      url += "?live_id=" + this.list[index].photoid;
      //如果有分享者uid就拼接上
      if (this.$route.query.uid) {
        url += "&uid=" + this.$route.query.uid;
      }
      //如果是分享的直播间，还要加上直播间的标识
      if (this.$route.query.share_live) {
        url += "&share_live=1";
      }
      window.location.href = url;
    },

    onPlayerCanplay() {
      var ua = navigator.userAgent.toLocaleLowerCase();
      if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        // x5内核
        let video = document.getElementsByTagName("video")[0];
        video.setAttribute("x5-video-player-type", "h5"); // 声明启用同层H5播放器，控制网页内部同层播放，可以在视频上方显示html元素。
        video.setAttribute("x5-video-orientation", "landscape|portrait"); // 播放器支持的方向--跟随手机自动旋转，此属性只在声明了x5-video-player-type=”h5”情况下生效
        video.setAttribute("x5-video-player-fullscreen", "true"); // 进入全屏通知
      } else {
        // ios端
        let video = document.getElementsByTagName("video")[0];
        video.setAttribute("webkit-playsinline", "true"); //设置ios在微信中内联播放视频 ios9
        video.setAttribute("playsinline", "true"); //设置ios在微信中内联播放视频 ios10/ios11
      }
    },

    /**视频播放结束 */
    video_over() {
      this.is_over = true;
    },

    /**重新播放 */
    re_play() {
      this.is_over = false;
    },

    /**跑马灯效果 */
    init_pmd() {
      let u2 = document.querySelector(".u2"),
        u = document.querySelector("#u"),
        u1 = document.querySelector(".u1");
      var width = u1.offsetWidth;
      if (width > u.offsetWidth) {
        u2.innerHTML = u1.innerHTML;
        setInterval(function () {
          if (u.scrollLeft >= width) {
            u.scrollLeft = 0;
          }
          u.scrollLeft += 1;
        }, 50);
      }
    },
  },
  computed: {
    palyer() {
      return this.$refs.videoPlayer.palyer;
    },
  },
  created: function () {
    var u = navigator.userAgent;
    this.in_Android = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
    if (!this.in_Android) {
      this.playsinline = true;
    }
  },
  mounted: function () {
    let _this = this;
    setTimeout(() => {
      _this.$tool.setTitle(_this.v_info.nickname + "朱贝视频");
      _this.open_install_thing();
      // _this.init_pmd(); //初始化跑马灯
    }, 300);
  },
};
</script>














<style scoped>
#video_v {
  z-index: 10;
}
.allA {
  z-index: 2;
}
/**顶部下载 */
.top-d {
  position: relative;
  align-items: center;
  justify-content: space-between;
  padding: 5px 16px;
  background: #fff;
}
.top-d .head {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  margin-right: 10px;
}
.top-d p {
  font-size: 14px;
  width: 59%;
}
.top-d .download-btn {
  width: 87px;
  height: 30px;
  right: 16px;
}
.top-d .download-btn img {
  width: 100%;
  height: 100%;
}

.video-shell {
  height: 470px;
}

/**覆盖区域 */
.part1 {
  align-items: center;
  color: #fff;
  top: 8px;
  left: 8px;
  z-index: 99999;
}
.part1 .head {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 8px;
  overflow: hidden;
}
.part1 .p1 {
  font-size: 14px;
}
.part1 .p2 {
  font-size: 11px;
}
.part1 a {
  width: 36px;
  height: 22px;
  margin-left: 16px;
}

.part2 {
  width: 95%;
  left: 8px;
  bottom: 8px;
}
.part2 .p1 {
  font-size: 15px;
  color: #fff;
}
.part2 .p2 {
  align-items: center;
  font-size: 12px;
  color: #fff;
}
.part2 .p2 img {
  width: 22px;
  height: 22px;
  margin-right: 8px;
}
.part2 .p2 span {
  margin-right: 23px;
}

/**结束之后界面 */
.over {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
  background: rgba(0, 0, 0, 0.8);
}
.over .btn {
  justify-content: space-between;
  width: 85%;
  margin: 0 auto;
}
.over .btn a {
  width: 47%;
}
ul {
  width: 83%;
  margin: 0 auto;
  margin-bottom: 16px;
  margin-top: 6%;
  justify-content: space-between;
  flex-wrap: wrap;
}
li {
  width: 49%;
  height: 180px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 6px;
}
.cover {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.play-icon {
  width: 30px;
}
.b-item {
  width: 100%;
  left: 0;
  bottom: 0;
  color: #fff;
  margin-bottom: 8px;
  padding: 0 8px;
}
.video .p1 {
  font-size: 13px;
  margin-bottom: 4px;
}
.video .p2 {
  font-size: 11px;
}

/**跑马灯 */
.pmd {
  width: 100%;
  overflow: hidden;
  height: 40px;
  padding: 26px 16px;
  padding-right: 111px;
}
.pmd #u {
  width: 100%;
  overflow-x: auto;
  word-break: keep-all;
  white-space: nowrap;
  transform: translateY(13px);
  padding-bottom: 24px;
}
.pmd .u1,
.pmd .u2 {
  display: inline;
  width: auto;
  font-size: 12px;
  word-break: keep-all;
  white-space: nowrap;
}
.pmd .u1 div,
.pmd .u2 div {
  display: inline-block;
  align-items: center;
  margin-right: 15px;
}
.pmd .u1 div *,
.pmd .u2 div * {
  vertical-align: middle;
}
</style>
<style>
/**视频区域 */
.video-player {
  position: relative;
  z-index: 0;
  height: 470px;
}
.video-js .vjs-tech {
  object-fit: cover !important;
}
</style>